import { fetchDgdgText } from "./dgdgFetch.js";
import { resolveDevalue } from "./devalue.js";
import { principalToAccountId } from "./icpAccountId.js";
const CANISTER_RE = /([a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-cai)/i;
const ENTREPOT_PROXY = "hdem4-ryaaa-aaaam-qa4xa-cai";
function pickCanisterFromCollection(col) {
    if (!col)
        return null;
    const direct = col.canister || col.ext;
    if (typeof direct === "string" && CANISTER_RE.test(direct)) {
        return direct.toLowerCase();
    }
    const canisters = col.canisters;
    if (canisters && typeof canisters === "object") {
        for (const key of ["entrepot", "memecake", "canister", "cap", "ext"]) {
            const v = canisters[key];
            if (typeof v === "string" && CANISTER_RE.test(v)) {
                const id = v.toLowerCase();
                if (id !== ENTREPOT_PROXY)
                    return id;
            }
        }
    }
    return null;
}
function canisterFromUrl(url) {
    if (!url)
        return null;
    const m = url.match(CANISTER_RE);
    const id = m?.[1]?.toLowerCase();
    return id && id !== ENTREPOT_PROXY ? id : null;
}
function tokenIndexNumber(nft) {
    if (typeof nft.tokenIndex === "number" && Number.isFinite(nft.tokenIndex)) {
        return nft.tokenIndex;
    }
    if (typeof nft.mintNumber === "number" && Number.isFinite(nft.mintNumber)) {
        return Math.floor(nft.mintNumber);
    }
    return null;
}
function nftName(slug, col, idx) {
    const label = col?.name || slug?.replace(/_/g, " ") || "ICP NFT";
    if (idx == null)
        return label;
    return `${label} #${idx + 1}`;
}
function rowToPortfolioNft(nft, col, ownerPrincipal) {
    const slug = (typeof nft.type === "string" ? nft.type : col?.shortName) || undefined;
    let canister = pickCanisterFromCollection(col) ||
        canisterFromUrl(nft.thumbnail) ||
        canisterFromUrl(typeof nft.mintNumber === "string" ? nft.mintNumber : undefined);
    if (!canister)
        return null;
    const idx = tokenIndexNumber(nft);
    const tokenId = idx != null
        ? String(idx)
        : typeof nft.tokenId === "string"
            ? nft.tokenId
            : typeof nft.tokenIndex === "string"
                ? nft.tokenIndex
                : null;
    if (!tokenId)
        return null;
    let imageUrl = nft.thumbnail ?? null;
    if (!imageUrl && idx != null) {
        imageUrl = `https://${canister}.raw.icp0.io/?index=${idx}&type=thumbnail`;
    }
    return {
        chain: "icp",
        contractId: canister,
        tokenId,
        name: nftName(slug, col, idx),
        imageUrl,
        walletAddress: ownerPrincipal,
        collectionName: col?.name?.trim() || null,
    };
}
function extractGroups(pool) {
    const out = [];
    const seen = new Set();
    for (const entry of pool) {
        if (!entry || typeof entry !== "object" || Array.isArray(entry))
            continue;
        const obj = entry;
        if (!("nfts" in obj))
            continue;
        const resolved = resolveDevalue(pool, entry);
        const col = resolved.collection
            ? resolveDevalue(pool, resolved.collection)
            : null;
        const nftsRaw = resolved.nfts;
        const rows = Array.isArray(nftsRaw)
            ? nftsRaw.map((n) => typeof n === "number" || typeof n === "string"
                ? resolveDevalue(pool, n)
                : n)
            : [];
        for (const row of rows) {
            if (!row || typeof row !== "object")
                continue;
            const nft = rowToPortfolioNft(row, col, "");
            if (!nft)
                continue;
            const key = `${nft.contractId}:${nft.tokenId}`;
            if (seen.has(key))
                continue;
            seen.add(key);
            out.push(nft);
        }
    }
    return out;
}
/** Fetch wallet holdings indexed by DGDG (same source as dgdg.app portfolio view). */
export async function fetchDgdgPortfolioByPrincipal(ownerPrincipal) {
    if (!ownerPrincipal)
        return [];
    const accountId = await principalToAccountId(ownerPrincipal);
    const path = `/nfts/collections/portfolio/__data.json?accountId=${encodeURIComponent(accountId)}&x-sveltekit-invalidated=01`;
    let text;
    try {
        text = await fetchDgdgText(path);
    }
    catch {
        return [];
    }
    const chunkLine = text.split("\n").find((l) => l.includes('"type":"chunk"'));
    if (!chunkLine)
        return [];
    let pool;
    try {
        pool = JSON.parse(chunkLine).data;
    }
    catch {
        return [];
    }
    const nfts = extractGroups(pool);
    return nfts.map((n) => ({ ...n, walletAddress: ownerPrincipal }));
}
